import React from 'react';
import ReviewCard from '../review-card';

export default function ReviewList({ reviews }) {
  return (
    <div className='grid gap-4'>
      {reviews.map((rev, index) => (
        <ReviewCard key={index} author={rev.author} content={rev.content} />
      ))}
    </div>
  );
}
